export const selectOptionTestId = (selectTestId, option)=>"".concat(selectTestId, "-option-").concat(option);
